/**
 * EditProfileModal.js — opens/closes the "Edit profile" dialog on profile.html
 */
export default class EditProfileModal {
  constructor() {
    this.trigger    = document.getElementById('edit-profile-trigger');
    this.modal      = document.getElementById('edit-profile-modal');
    this.backdrop   = document.getElementById('edit-profile-backdrop');
    this.closeBtn   = document.getElementById('edit-profile-close');
    this.cancelBtn  = document.getElementById('edit-profile-cancel');
    this.form       = document.getElementById('edit-profile-form');

    if (!this.trigger || !this.modal) return;

    this.firstInput = this.modal.querySelector('input');

    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    });

    this.backdrop?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.cancelBtn?.addEventListener('click', () => this.close());

    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.firstInput?.focus(), 50);
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}
